//#region libraries
import React from 'react'
import { useDispatch, useSelector } from 'react-redux';

//redux
import { selectPreBoard, setPreBoard } from '_redux/slices/timeline/timeline-control';
import { selectUsedTheme } from '_redux/slices/timeline/theme';

//bootstrap
import { Form } from 'react-bootstrap';

//#endregion
const PreBoardSwitch = () => {

    //redux
    const dispatch = useDispatch();
    const preBoard = useSelector(selectPreBoard);                       // status of auto accept unplaned task switch
    const usedTheme = useSelector(selectUsedTheme);

    const handleSwitch = () => {
        dispatch(setPreBoard(!preBoard));
    }

    return (

        <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '20px' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ fontSize: '16px', color: 'gray', fontWeight: '500' }}>
                    Preboard Bookings
                </span>
                <Form.Check
                    onChange={handleSwitch}
                    type="switch"
                    checked={preBoard}
                    value={preBoard}
                    style={{ marginLeft: "16px" }}
                />
            </div>
            <span style={{ color: usedTheme.TEXT_COLOR, fontSize: '14px', marginTop: '4px' }}>
                Display boarding cards for departure passenges at the boarding time of each flight (45 minutes before flight departure time)
            </span>
        </div>


    )
}

export default PreBoardSwitch